<template>
    <section v-if="myRankMain || myRankWeekly" class="current-position">
        <v-container>
            <v-row>
                <v-col cols="14" offset="1" md="10" offset-md="3">
                    <v-row>
                        <v-col cols="16">
                            <h2 class="section-subtitle">Aktuální pořadí</h2>
                        </v-col>
                        <v-col cols="16" sm=7 offset-sm="1" v-if="myRankWeekly">
                            <v-card :to="{ name: 'tournamentDetail', params: { id: myRankWeekly.id } }">
                                <v-card-title class="section-smalltitle"><span class="section-smalltitle--thin"> {{ myRankWeekly.name }}</span></v-card-title>
                                <v-card-text>
                                    <div v-if="myRankWeekly.score !== null">
                                        <v-row>
                                            <v-col>
                                                <p>Pořadí</p>
                                            </v-col>
                                            <v-col>
                                                <p>Počet bodů</p>
                                            </v-col>
                                        </v-row>
                                        <div class="current-position__box">
                                            <v-row>
                                                <v-col>
                                                    <span class="current-position__rank">{{ myRankWeekly.rank | formatRank }}</span>
                                                </v-col>
                                                <v-col>
                                                    <span class="current-position__score">{{ myRankWeekly.score }} bodů</span>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                    <p v-else>bez umístění</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="16" sm=7 offset-sm="1" v-if="myRankMain">
                            <v-card :to="{ name: 'tournamentDetail', params: { id: myRankMain.id } }">
                                <v-card-title class="section-smalltitle"><span class="section-smalltitle--thin"> {{ myRankMain.name }}</span></v-card-title>
                                <v-card-text>
                                    <div v-if="myRankMain.score !== null">
                                        <v-row>
                                            <v-col>
                                                <p>Pořadí</p>
                                            </v-col>
                                            <v-col>
                                                <p>Počet bodů</p>
                                            </v-col>
                                        </v-row>
                                        <div class="current-position__box">
                                            <v-row>
                                                <v-col>
                                                    <span class="current-position__rank">{{ myRankMain.rank | formatRank }}</span>
                                                </v-col>
                                                <v-col>
                                                    <span class="current-position__score">{{ myRankMain.score }} bodů</span>
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                    <p v-else>bez umístění</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { TOURNAMENTS_MY_RANK_REQUEST } from '../../store/actions/tournament';

    export default {
        name: 'CurrentRank',
        computed: {
            ...mapGetters('tournament', [
                'myRankMain',
                'myRankWeekly',
            ]),
        },
        created () {
            this.$store.dispatch('tournament/' + TOURNAMENTS_MY_RANK_REQUEST);
        },
    }
</script>
